import { useMemo } from 'react';
import { Flex, Pane, Text } from '@leverege/ui-elements';
import { Toolbar } from '@leverege/ui-plugin';
import classnames from 'classnames';
import mpegts from 'mpegts.js';
import I18N from '@leverege/i18n';
import S from './Controls.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const {
  t
} = I18N.ns('ui-video.player.shared.Controls');
export default function Controls(props) {
  const {
    domRef,
    fullscreenSupported,
    isLoading,
    isPlaying,
    isVisible,
    onFullscreen,
    onPictureInPicture,
    onPlayPause,
    pictureInPictureSupported,
    error,
    poster: pPoster,
    client,
    context: pContext,
    isFullscreen,
    isPoppedOut
  } = props;
  const errorMessage = useMemo(() => {
    if (error) {
      let message;
      switch (error.type) {
        case mpegts.ErrorTypes.NETWORK_ERROR:
          {
            if (error.original?.code === 403) {
              message = t('forbiddenError');
            } else {
              message = t('networkError');
            }
            break;
          }
        case mpegts.ErrorTypes.MEDIA_ERROR:
          message = t('mediaError');
          break;
        case mpegts.ErrorTypes.OTHER_ERROR:
          message = t('generalError');
          break;
        default:
          message = t('unknownError');
      }
      message += ` ${t('reload')}`;
      return message;
    }
    return null;
  }, [error]);
  const poster = useMemo(() => {
    switch (typeof pPoster) {
      case 'string':
        return /*#__PURE__*/_jsx(Text, {
          variant: "videoControlsPoster",
          onClick: onPlayPause,
          className: classnames(S.overlay, S.poster),
          children: pPoster
        });
      case 'object':
        if (pPoster != null) {
          return pPoster;
        }
      // eslint-disable-next-line no-fallthrough
      default:
        return /*#__PURE__*/_jsx(Text, {
          variant: "videoControlsPoster",
          onClick: onPlayPause,
          className: classnames(S.overlay, S.poster)
        });
    }
  }, [pPoster, onPlayPause]);
  const {
    clientProps: {
      objectType,
      path
    }
  } = pContext;
  const playMatchContext = useMemo(() => {
    return {
      client,
      path,
      objectType,
      use: 'videoPlayBar'
    };
  }, [client, path, objectType]);
  const optionsMatchContext = useMemo(() => {
    return {
      client,
      path,
      objectType,
      use: 'videoOptionsBar'
    };
  }, [client, path, objectType]);
  const context = useMemo(() => {
    return {
      ...pContext,
      fullscreenSupported,
      isFullscreen,
      isLoading,
      isPlaying,
      isPoppedOut,
      onFullscreen,
      onPictureInPicture,
      onPlayPause,
      pictureInPictureSupported
    };
  }, [fullscreenSupported, isFullscreen, isLoading, isPlaying, isPoppedOut, onFullscreen, onPictureInPicture, onPlayPause, pContext, pictureInPictureSupported]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [errorMessage && /*#__PURE__*/_jsx(Text, {
      className: classnames(S.overlay, S.error),
      variant: "videoControlsError",
      children: errorMessage
    }), isLoading && !error && /*#__PURE__*/_jsxs(Flex, {
      variant: "colMCenter",
      className: S.overlay,
      children: [/*#__PURE__*/_jsx(Text, {
        className: classnames(S.loader),
        variant: "videoControlsLoader"
      }), /*#__PURE__*/_jsx(Text, {
        variant: "videoControlsMessage",
        children: t('patience')
      })]
    }), poster && !isPlaying && !isLoading && !error && poster, /*#__PURE__*/_jsxs(Pane, {
      domRef: domRef,
      variant: "videoControls",
      className: classnames(S.controls, isVisible && S.visible),
      layout: "flex:rowSpaceBetween",
      children: [/*#__PURE__*/_jsx(Toolbar, {
        variant: "videoPlayBar",
        matchContext: playMatchContext,
        context: context
      }), /*#__PURE__*/_jsx(Toolbar, {
        variant: "videoOptionsBar",
        matchContext: optionsMatchContext,
        context: context
      })]
    })]
  });
}